module.exports = __webpack_public_path__ + "static/fingers-be1c5ceeb5cf186bd423aa7f5a8e2b8c.png";